import { useAuthStore } from '@/store/authStore';

/** Education LMS permission flags (education.lms.view / manage / submit; admin implies view + manage). */
export function useLmsAccess() {
  const permissions = useAuthStore((s) => s.user?.permissions || []);
  const isAdmin = permissions.includes('education.admin');
  const canManage = isAdmin || permissions.includes('education.lms.manage');
  const canView = canManage || permissions.includes('education.lms.view');
  const canSubmit = permissions.includes('education.lms.submit');
  return { canManage, canView, canSubmit };
}

export function lmsErrorMessage(error: unknown, fallback: string): string {
  const message = (error as { response?: { data?: { message?: string } } })?.response?.data?.message;
  return message || fallback;
}

export const LMS_HOME_PATH = '/education/lms';
